import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',

      '& .MuiOutlinedInput-root': {
        height: '50px!important',
        fontSize: 14,
        background: '#0e1319',
        maxWidth: 390,
      },

      '& .MuiFormLabel-root': {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '13px',
        letterSpacing: '1px',
        alignItems: 'center',
        color: '#c2ccd8',

        '& .MuiBox-root': {
          padding: '2px 4px 1px 5px',
          border: '1px solid',
          borderRadius: '100%',
          fontSize: '12px',
        },
      },

      '& .MuiSelect-iconOutlined': {
        right: '0',
        top: '22px',
      },

      '& .MuiSelect-iconOpen': {
        top: '2px',
        right: '13px',
      },

      marginBottom: 20,
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 50,
      textAlign: 'center',
      [theme.breakpoints.down(960)]: {
        marginBottom: 30,
      },
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
      // maxWidth: 'fit-content',
    },
    chips: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: '#28313f',
      height: 50,
      borderRadius: 5,
      padding: '0 20px',

      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
        fontSize: 18,
        '& path': {
          fill: '#d83032',
        },
      },
    },
    input: {
      maxWidth: 450,
      background: 'none',
      borderRadius: 8,
      fontWeight: 400,
      '& input': {
        fontSize: 14,
      },
      '& .MuiInputBase-root': {
        paddingLeft: 20,
        borderRadius: 8,
      },
    },
    startIcon: {
      fontSize: 20,
      marginRight: 5,
    },
    helpText: {
      color: '#60718b',
      textAlign: 'left',
      // maxWidth: 390,
    },
  }),
);
